module.exports = __webpack_public_path__ + "img/13_maska_kniga.77f7968.svg";